import React from "react";

export default function ManualPage() {
	return (
		// Asumiendo Tailwind CSS
		<div className="flex justify-center p-4">
			{" "}
			{/* Contenedor centrado y con padding general */}
			<iframe
				src="https://irp.cdn-website.com/c623c916/files/uploaded/manual.procedimientos.CentralENT.2025.V.1.pdf"
				// Estilos para ocupar la mayor parte del ancho y una altura definida
				className="border-none w-full max-w-4xl h-[800px] shadow-lg"
				title="Manual de procedimiento"
				loading="lazy"
			></iframe>
		</div>
	);
}
